import { defineMeta } from '@/registry/types';

export const sparklineMeta = defineMeta({
  name: 'Sparkline',
  level: 'atom',
  category: 'data-display',
  classification: 'custom',
  description:
    'Dependency-free trend line for dense contexts such as table cells and stat tiles. Consolidates six divergent hand-rolled implementations; normalisation and decoration are explicit props.',
  baseLibrary: 'custom',
  importPath: '@/atoms/Sparkline',
  requiredProps: ['data', 'label'],
  optionalProps: [
    'variant',
    'normalize',
    'tone',
    'showEndPoint',
    'width',
    'height',
    'strokeWidth',
  ],
  customVariants: ['line', 'area'],
  supportedStates: ['default', 'flat', 'empty'],
  designTokens: ['chart', 'severity'],
  accessibility: [
    'Renders role="img" with a required aria-label; a sparkline carries information and must not be hidden from assistive technology.',
    'Never the sole carrier of a value — pair with the numeric value in the surrounding cell or tile.',
  ],
  usageExamples: [
    '<Sparkline data={[3, 5, 4, 9]} label="Alert volume, last 4 weeks" />',
    '<Sparkline data={counts} variant="area" tone="high" showEndPoint label="High severity trend" />',
  ],
  antiPatterns: [
    'Do not use minMax normalisation when absolute magnitude matters — it exaggerates small movements.',
    'Do not use for more than one series; use LineChart from @aistrike-dev/ui/charts.',
  ],
  llmSafe: true,
  whenToUse: ['Compact trend inside a table row, stat tile or list item'],
  whenNotToUse: ['Anything needing axes, a legend or multiple series'],
});

export default sparklineMeta;
